import _ from 'lodash';
export default (function (requireList, data) {
  var result = [];

  _.forEach(requireList, function (item) {
    if (!data[item] || Array.isArray(data[item]) && !data[item].length) result.push(item);
  });

  return result;
});